// extracted by mini-css-extract-plugin
export default {"main":"MyAccountLayout_main__1BmqO","container":"MyAccountLayout_container__Rs2Qd"};